import { z } from 'zod';

import { createZodStringParser } from '@Common/types/zod/zod-parse-string';

function transformStringToNumber(value: string) {
  return value !== '' ? Number(value) : value;
}

export const ZodNumberLike = createZodStringParser(
  z.number(),
  z
    .string()
    .transform(transformStringToNumber)
    .meta({ override: { type: 'number' } }),
);

export const ZodIntegerLike = createZodStringParser(
  z.number().int(),
  z
    .string()
    .transform(transformStringToNumber)
    .meta({ override: { type: 'number' } }),
);

export function createZodNumberLike<Type extends z.ZodNumber>(type: Type) {
  return createZodStringParser(
    type,
    z
      .string()
      .transform(transformStringToNumber)
      .meta({ override: { type: 'number' } }),
  );
}
